// featureFlagApi.ts

import { nodeApi } from "@/redux/api/nodeApi";


export const featureFlagApi = nodeApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllFeatures: builder.query({
      query: ({
        email,
        featureKey,
      }: {
        email: string;
        featureKey: string;
      }) => ({
        url: `/feature-flag/get-features?email=${email}&featureKey=${featureKey}`,
        method: "GET",
      }),
    }),
    checkFeatureApproved: builder.query({
      query: ({
        email,
        featureKey,
      }: {
        email: string;
        featureKey: string;
      }) => ({
        url: `/feature-flag/check-approved?email=${email}&featureKey=${featureKey}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetAllFeaturesQuery, useCheckFeatureApprovedQuery } =
  featureFlagApi;
